import { lazy } from 'react';

type LottieEffectOverlayModule = typeof import('.');

let modulePromise:
    | Promise<{ default: LottieEffectOverlayModule['LottieEffectOverlay'] }>
    | undefined;

export const preloadLottieEffectOverlay = () => {
    modulePromise ??= import('.').then((module) => ({
        default: module.LottieEffectOverlay,
    }));

    return modulePromise;
};

export const LazyLottieEffectOverlay = lazy(preloadLottieEffectOverlay);
